import { IChangeRouteAction } from './types';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
import { showAlert } from '../alert';
import { getArchivedChats } from '../archivedList';
import { getChats } from '../chatList/getChats';
import { getUnreadChats } from '../chatList/getUnreadChats';
import { EInternetStatus } from '../internetStatus';
import { getSpamChats } from '../spamList';

export const changeRoute =
  ({ route, notClearCurrentOpenedChatId }: IChangeRouteAction): TThunkAction<void> =>
  (dispatch, getState) => {
    const state = getState();

    const { internetStatus } = state;
    if (internetStatus !== EInternetStatus.Online) {
      dispatch(showAlert({ message: 'Нет сети' }));

      return;
    }

    /**
     * При переходе в список сообщений запрашиваем v1/chats и переписываем chatList в активные чаты
     */
    if (route === ERoute.Messages) {
      dispatch(getChats({ timestamp: undefined, notClearCurrentOpenedChatId }));
    }

    /**
     * При переходе в список непрочитанных сообщений запрашиваем v1/chats и фильтруем непрочитанные чаты
     */
    if (route === ERoute.Unread) {
      dispatch(getUnreadChats({ timestamp: undefined, notClearCurrentOpenedChatId }));
    }

    /**
     * При переходе в спам
     *  - запрашиваем v1/get-spam-chats-desktop без timestamp, чтобы всегда загружать с первой страницы.
     *  - переписываем chatList в чаты из спама
     *  - ставим активный роут "Спам"
     */
    if (route === ERoute.Spam) {
      dispatch(getSpamChats({ timestampSpam: undefined }));
    }

    /**
     * При переходе в архив
     *  - запрашиваем v1/chats/get-archived-chats-desktop без timestamp, чтобы всегда загружать с первой страницы.
     *  - переписываем chatList в чаты из архива
     *  - ставим активный роут "Архив"
     */
    if (route === ERoute.Archive) {
      dispatch(getArchivedChats({ timestampArchive: undefined }));
    }
  };
